import { CoreInitiativesSonarObjectsName } from './name';
import { deleteInitiativeSonarObjects } from '@api';
import { refreshCurrentInitiativeSummarySaga } from '../summary/get';
import { updateInitiativeReferences } from '../_idMap/actions';
import { updateSonarObjectReferences } from '../../sonar-objects/_idMap/actions';
import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createDeleteAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreInitiativesSonarObjectsDeleteAsyncSlice = createDeleteAsyncSlice({
	additionalReceiveSteps: [
		{
			actionHandler: refreshCurrentInitiativeSummarySaga,
			type: SagaYieldType.Every
		}
	],
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.SCOPE_CHANGED, ({ data }) => ({
				action: 'deleted',
				description: `${data.sonarObjectIds} from initiative ${data.initiativeId}`
			})),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) =>
				updateSonarObjectReferences(
					request.sonarObjectIds.map((id) => ({
						initiatives: { toRemove: request.initiativeId },
						sonarObjectId: id
					}))
				),
			(request) =>
				updateInitiativeReferences([
					{
						initiativeId: request.initiativeId,
						tasks: {
							toUpdateAll: (entry) => ({
								...entry,
								sonarObjects: entry.sonarObjects.filter(
									(item) => !request.sonarObjectIds.includes(item.sonarObjectId)
								)
							})
						}
					}
				])
		]
	},
	name: CoreInitiativesSonarObjectsName,
	receive: false,
	request: true,
	requestHandler: deleteInitiativeSonarObjects,
	yieldType: SagaYieldType.Every
});
